import React, { useState, useEffect } from "react";
import _ from "lodash";
import {
  _findSelectOption,
  _getBaseUrl,
  _capitalized,
  _isFirstRender,
  _getSkipByPage,
  _getCSRFTokenValue,
  _getTranslation,
  _getPlaceHolderKey,
} from "../../utils/helper";
import api from "../../utils/api";

import { Loader, Pagination } from "../../atoms";
import { CardPublication } from "../../cards";
import {
  Datepicker,
  InputSearch,
  InputSelect,
  MobileFilters,
} from "../../forms";

const INITIAL_VALUES = {
  searchTerm: "",
  // date: "",
  start_date: "",
  end_date: "",
  type: "",
  page: 1,
};

const PublicationsByRegionOrCountry = (props) => {
  const [values, setValues] = useState(INITIAL_VALUES);
  const [nodeId, setNodeId] = useState("");
  const [pageType, setPageType] = useState("");

  const [appliedFilters, setAppliedFilters] = useState(INITIAL_VALUES);
  const [posts, setPosts] = useState([]);
  const [filterOptions, setFilterOptions] = useState([]);
  const [isLoadingFilters, setIsLoadingFilters] = useState(false);
  const [isLoadingPosts, setIsLoadingPosts] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const isFirstLoad = _isFirstRender();

  useEffect(() => {
    if (props?.data) {
      setNodeId(props?.data?.nid ? parseInt(props?.data?.nid) : "");
      setPageType(props?.data["page-type"] || "");
    }
  }, [props?.data]);

  useEffect(() => {
    if (nodeId !== "" && pageType !== "") {
      fetchFilters();
      fetchPosts();
    }
  }, [nodeId, pageType]);

  useEffect(() => {
    // sync the values when filters are applied
    setValues(appliedFilters);

    if (!isFirstLoad) {
      const debouncedFetchPosts = setTimeout(() => {
        fetchPosts();
      }, 500);
      return () => clearTimeout(debouncedFetchPosts);
    }
  }, [appliedFilters]);

  const fetchFilters = () => {
    setIsLoadingFilters(true);

    const paramUrl = `node_id=${nodeId}&node_type=${pageType}`;

    api
      .get(`/publication/gettypesbyregionorcountry?${paramUrl}`)
      .then((res) => {
        setIsLoadingFilters(false);
        const filtersData = res.data;
        const filtersDataNew = [
          {
            "value": "briefs",
            "label": "Briefs"
          },
          {
            "value": "case-studies",
            "label": "Case studies"
          },
          {
            "value": "reports",
            "label": "Reports"
          },
          {
            "value": "handbooks",
            "label": "Handbooks"
          }
        ];
        const formattedList = [
          {
            label: "Type",
            key: "type",
            options: filtersDataNew,
          },
        ];
        setFilterOptions(formattedList);
      })
      .catch(() => {
        setIsLoadingFilters(false);
      });
  };

  const fetchPosts = async () => {
    setIsLoadingPosts(true);

    const POSTS_PER_PAGE = 8;
    const POSTS_SKIP = _getSkipByPage(appliedFilters.page, POSTS_PER_PAGE);

    const fields = {
      theme: "",
      // date: appliedFilters.date,
      startdate: appliedFilters.start_date,
      enddate: appliedFilters.end_date,
      region: pageType === "region" ? nodeId : "",
      country: pageType === "country" ? nodeId : "",
      type: appliedFilters.type,
      searchTerm: appliedFilters.searchTerm,
      skip: POSTS_SKIP,
      take: POSTS_PER_PAGE,
    };

    const csrfToken = await _getCSRFTokenValue();
    api
      .post("/publication/basicsearch", fields, {
        headers: {
          "X-CSRF-Token": csrfToken,
        },
      })
      .then((res) => {
        const TOTAL_POSTS = res.data.totalNodes;
        const TOTAL_PAGES = Math.ceil(TOTAL_POSTS / POSTS_PER_PAGE);

        setIsLoadingPosts(false);
        setPosts(res.data.publications);
        setTotalPages(TOTAL_PAGES);
      })
      .catch(() => {
        setIsLoadingPosts(false);
      });
  };

  const getFilterInputs = () => {
    return isLoadingFilters ? (
      <Loader />
    ) : (
      <React.Fragment>
        <div className="filter-item sm:col-span-2 flex flex-col sm:flex-row sm:items-center gap-y-3 gap-x-4">
          <label className="hidden sm:block font-semibold">
            {_getTranslation("filter_by")}
          </label>
          {/* <Datepicker
            class="flex-1"
            value={values.date}
            placeholder={`${_getTranslation("date")}`}
            onChange={(selected) => {
              setValues({
                ...values,
                date: selected,
              });
            }}
          /> */}
          <div className="flex items-start gap-4">
            <label className="mt-4 text-sm w-10">{_getTranslation("from")}</label>
            <Datepicker
              value={values.start_date}
              class="flex-1"
              isNoIcon={true}
              onChange={(selected) => {
                setValues({
                  ...values,
                  start_date: selected,
                  end_date: null,
                });
              }}
            />
          </div>
          <div className="flex items-start gap-4">
            <label className="mt-4 text-sm w-4">{_getTranslation("to")}</label>
            <Datepicker
              value={values.end_date}
              class={`flex-1 ${_.isEmpty(values.start_date)
                ? "pointer-events-none opacity-50"
                : ""
                }`}
              isNoIcon={true}
              onChange={(selected) => {
                setValues({
                  ...values,
                  end_date: selected,
                });
              }}
            />
          </div>
          {filterOptions.map((item) => (
            <InputSelect
              class="flex-1"
              name={item.key}
              // placeholder={item.label}
              placeholder={`${_getTranslation(item.label.toLowerCase())}`}
              options={item.options}
              isClearable
              isSearchable
              value={_findSelectOption(item.options, values[item.key])}
              onChange={(name, selectedValues) => {
                setValues({
                  ...values,
                  [item.key]: selectedValues,
                });
              }}
            />
          ))}
        </div>

        <div className="grid sm:grid-cols-2 gap-y-2 gap-x-4 lg:gap-x-2 sm:col-span-2 lg:col-auto sm:mt-4 lg:mt-0">
          <button className="btn btn-s--pill" onClick={() => applyFilters()}>
            {_getTranslation("apply_filters")}
          </button>
          {!_.isEqual(values, INITIAL_VALUES) && (
            <button
              className="btn btn-s--pill btn-c--hollow---black"
              onClick={() => resetFilters()}
            >
              {_getTranslation("reset_filters")}
            </button>
          )}
        </div>
      </React.Fragment>
    );
  };

  const applyFilters = (pageNo = 1) => {
    setAppliedFilters({ ...values, page: pageNo });
  };

  const resetFilters = () => {
    setValues(INITIAL_VALUES);
    setAppliedFilters(INITIAL_VALUES);
  };

  return (
    <div className="container">
      <h2 className="h2 !mb-4">{_getTranslation("publications")}</h2>

      <div className="desktop-filters hidden sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 items-center gap-y-2 gap-x-4 sm:gap-x-8 mb-8">
        <div className="filter-item col-span-2 lg:col-auto">
          <InputSearch
            class="w-full"
            placeholder={_getTranslation("type_in_your_keywords")}
            value={values.searchTerm}
            onChange={(e) => {
              const value = e.target.value;
              setValues({ ...values, searchTerm: value });
            }}
          />
        </div>
        {getFilterInputs()}
      </div>

      <MobileFilters class="w-full sm:hidden mb-6">
        <div className="filter-item w-full">
          <InputSearch
            class="w-full"
            placeholder={_getTranslation("type_in_your_keywords")}
            value={values.searchTerm}
            onChange={(e) => {
              const value = e.target.value;
              setValues({ ...values, searchTerm: value });
            }}
          />
        </div>
        {getFilterInputs()}
      </MobileFilters>

      {isLoadingPosts && <Loader class="mb-8" />}
      {_.isArray(posts) && posts.length > 0 ? (
        <React.Fragment>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8 mb-8">
            {posts.map((post) => (
              <CardPublication data={post} />
            ))}
          </div>
          <Pagination
            page={appliedFilters.page}
            totalPages={totalPages}
            setPage={(newPage) => {
              applyFilters(newPage);
            }}
          />
        </React.Fragment>
      ) : isLoadingPosts ? null : (
        <p>{_getTranslation("there_are_no_posts_available")}.</p>
      )}
    </div>
  );
};

export default PublicationsByRegionOrCountry;
